import {
    type ViewStyle,
    type TextStyle,
    StyleSheet
} from "react-native";
import type {
    TraceCodeBlockDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    getCodeTextStyle
} from "../../../codeViewer/stylesheet";
import {
    webStyle
} from "../../../../utils";

export const TRACE_CODE_MAX_LINES = 8;

export const TRACE_CODE_LANGUAGE = "json";

const stylesheet = StyleSheet.create({
    head: {
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row"
    },
    container: {
        flexDirection: "column",
        overflow: "hidden",
        minWidth: 0
    },
    body: {
        flexDirection: "column"
    },
    code: {
        ...webStyle({
            whiteSpace: "pre"
        })
    }
});

export const useStyles = ({
    controlPaddings,
    shapeConfigs,
    typography,
    radiuses,
    borders,
    colors,
    spaces
}: TraceCodeBlockDynamicStyleType) => {
    const codeTextStyle = getCodeTextStyle({
        typography
    });

    const styles = {
        container: {
            backgroundColor: colors.content.container.subtle,
            ...getCornerStyle({
                radius: radiuses.form,
                shapeConfigs
            })
        } as Mutable<ViewStyle>,
        head: {
            borderBottomColor: colors.content.border.subtle,
            borderBottomWidth: borders.separator,
            padding: spaces.spacingXs,
            paddingStart: controlPaddings.small,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>,
        code: {
            ...codeTextStyle,
            lineHeight: typography.bodySmallSize.lineHeight,
            fontSize: typography.bodySmallSize.fontSize
        } as Mutable<TextStyle>,
        body: {
            paddingHorizontal: controlPaddings.small,
            paddingVertical: spaces.spacingSm
        } as Mutable<ViewStyle>,
        more: {
            paddingHorizontal: controlPaddings.small,
            paddingBottom: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
